<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-25 10:52:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 16:37:56
 * @FilePath: /chaoyongtuan/src/views/teamManage/delegationHead/components/tableCells/timerCells.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="timer-cells">
		<div class="text">{{ row.add_time | formatEmpty }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>
<style scoped lang="less">
.text {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	color: @color-gy9;
}
</style>
